export const supportEmail = "timsupport@timgroup.com";